import React from 'react';
import './MoonsFlow.css';
import MoonsFlowStep from './../Components/Presentation/MoonsFlowStep/MoonsFlowStep';

class MoonsFlow extends React.Component {
  constructor() {
    super();
    this.state = { someKey: 'someValue' };
  }

  render() {
    return (
        <div className="container moons-flow-container">
            <div className="vertical-separator-30px"></div>
            
            <div className="row">
                <div className="col-md-6 col-md-offset-3 text-center">
                    <h4>¿Cómo funciona Dr. moons?</h4>
                </div>
            </div>

            <div className="vertical-separator-30px"></div>

            <div className="row">
                <div className="col-md-3 col-md-offset-2 text-center">
                    <MoonsFlowStep
                        icon="checklist"
                        stepNumber="01"
                        text="Completa los datos de tu paciente en la plataforma Dr. moons para crear su expediente electrónico."
                    />
                    
                    <div className="vertical-separator-step"></div>

                    <MoonsFlowStep
                        icon="deliverytruck"
                        stepNumber="03"
                        text="Programa la recolección de impresiones para que nuestro mensajero las recoja. Si haces el estudio con uno de nuestros centros afiliados, nosotros nos encargamos de todo."
                    />

                    <div className="vertical-separator-step"></div>

                    <MoonsFlowStep
                        icon="website"
                        stepNumber="05"
                        text="En 4 días hábiles, recibe el plan, duración estimada, un video en 3D con los resultados esperados y las especificaciones del caso en esta plataforma."
                    />

                    <div className="vertical-separator-step"></div>

                    <MoonsFlowStep
                        icon="conveyor"
                        stepNumber="07"
                        text="Una vez que aceptes el plan, empezaremos a producir los moons para tu paciente."
                    />

                    <div className="vertical-separator-step"></div>

                    <MoonsFlowStep
                        icon="dentistchair"
                        stepNumber="09"
                        text="¡Listo! Ya puedes empezar a tratar a tu paciente. Si necesitas apoyo de nuestro expertos, comunícate con nosotros."
                    />
                </div>
                <div className="col-md-2 text-center">
                    <div className="moonsflow divisor"></div>
                </div>
                <div className="col-md-3 text-center">
                    <div className="vertical-separator-step"></div>
                    
                    <MoonsFlowStep
                        icon="mouth"
                        stepNumber="02"
                        text="Pide a tu paciente que se realice un escaneo en 3D o toma de impresiones en uno de nuestros Centro Radiológicos afiliados o con el proveedor que prefieras."
                    />
                    
                    <div className="vertical-separator-step"></div>
                    
                    <MoonsFlowStep
                        icon="dental"
                        stepNumber="04"
                        text="Nuestro equipo de Ortodoncistas recibe el caso para hacer la planeación del tratamiento, con base en tus preferencias."
                    />

                    <div className="vertical-separator-step"></div>
                    
                    <MoonsFlowStep
                        icon="positivevote"
                        stepNumber="06"
                        text="Revisa y acepta el plan. Si tienes cambios o comentarios, contáctanos."
                    />

                    <div className="vertical-separator-step"></div>
                    
                    <MoonsFlowStep
                        icon="mouth"
                        stepNumber="08"
                        text="En 2 semanas, recibe en tu consultorio todos los alineadores para el caso en un solo paquete."
                    />

                </div>
            </div>

            <div className="vertical-separator-30px"></div>

        </div>
    )
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }
}

export default MoonsFlow;



// WEBPACK FOOTER //
// ./src/views/Info/MoonsFlow.js